import { MerchantDto } from "../../dto/merchant.dto";


export class RealtimePayload{
    type: string;
    data: any;
    authToken?: string;
    merchant?: MerchantDto;
    room?: string;
}